<template>
  <!--
    	作者：wangxw
    	时间：2019-10-26
    	描述：产品分类管理
    -->
  <div class="product" style="height: calc(100vh - 160px)">
    <!--添加产品分类-->
    <!--    <div class="common-level-rail">-->
    <!--      <el-button size="small" type="primary" @click="addClick" icon="el-icon-plus" v-auth="'/product/crop/add'">-->
    <!--        添加分类/作物-->
    <!--      </el-button>-->
    <!--    </div>-->
    <!--内容-->
    <div class="product-content h-full">
      <!--      <div class="table-wrap">-->
      <!--        <el-table size="small" :data="tableData" row-key="id" :default-expand-all="false"-->
      <!--                  :tree-props="{children: 'children'}"-->
      <!--                  style="width: 100%" v-loading="loading">-->
      <!--          <el-table-column prop="name" label="分类/作物名称" min-width="180"></el-table-column>-->
      <!--          <el-table-column prop="" label="图片" width="180">-->
      <!--            <template slot-scope="scope">-->
      <!--              <img v-img-url="hasImages(scope.row.imagePath)" alt="" width="50px"/>-->
      <!--            </template>-->
      <!--          </el-table-column>-->
      <!--          <el-table-column prop="sort" label="分类/作物排序" width="120"></el-table-column>-->
      <!--          <el-table-column prop="createTime" label="添加时间" width="175"></el-table-column>-->
      <!--          <el-table-column fixed="right" label="操作" width="100">-->
      <!--            <template slot-scope="scope">-->
      <!--              <el-button @click="editClick(scope.row)" type="text" size="small" v-auth="'/product/crop/edit'">编辑-->
      <!--              </el-button>-->
      <!--              <el-button @click="deleteClick(scope.row)" type="text" size="small" v-auth="'/product/crop/delete'">-->
      <!--                删除-->
      <!--              </el-button>-->
      <!--            </template>-->
      <!--          </el-table-column>-->
      <!--        </el-table>-->
      <!--      </div>-->
      <div class="h-full flex o-hidden" style="border: 1px solid #EDEDED;width: 100%">
        <div class=" h-full  flex-s-0" style="width:20%;border-right: 1px solid #EDEDED">
          <div class="fs-16 flex a-center p-h-15" style="color: #333333;height: 50px;border-bottom: 1px solid #EDEDED;">
            <slot name="classType">
              <div class="fs-14">作物类型</div>
            </slot>
            <div class="flex-1"></div>
            <div @click="addClick(0)" class="flex a-center">
              <span class="fs-14" style="color: #0652DD;cursor: pointer">添加</span>
            </div>
          </div>
          <div class="o-y-auto noscroll" style="height: calc(100% - 50px)">
            <ul>
              <li v-for="(item,index) in tableData" :key="index" :class="{'active': cropModel.typeId === item.id}"
                  @click="onTypeSelect(item)"
                  class="w-full p-h-15 lh-40 h-40 liHover flex a-center j-between">
                {{ item.name }}
                <div :class="{'selectHover1':cropModel.typeId === item.id}" class="selectHover d-none">
                  <img @click.stop="editClick(item)" alt="" class="w-15 h-15 m-r-10"
                       src="../../../assets/common/ic_xiugai.png">
                  <img @click.stop="deleteClick(item)" alt="" class="w-15 h-15"
                       src="../../../assets/common/ic_shanchu1.png">
                </div>
              </li>
            </ul>
          </div>
        </div>
        <div class=" h-full  flex-s-0" style="width:20%;border-right: 1px solid #EDEDED">
          <div class="fs-16 flex a-center p-h-15" style="color: #333333;height: 50px;border-bottom: 1px solid #EDEDED;">
            <slot name="classType">
              <div class="fs-14">作物</div>
            </slot>
            <div class="flex-1"></div>
            <div @click="addClick(1)" class="flex a-center" v-if="cropModel.typeId">
              <span class="fs-14" style="color: #0652DD;cursor: pointer">添加</span>
            </div>
          </div>
          <div class="o-y-auto noscroll" style="height: calc(100% - 50px)">
            <ul>
              <li v-for="(item,index) in cropList" :key="index" :class="{'active': cropModel.cropId === item.id}"
                  @click="onCropSelect(item)"
                  class="w-full p-h-15 lh-40 h-40 liHover flex a-center j-between">
                {{ item.name }}
                <div :class="{'selectHover1':cropModel.cropId === item.id}" class="selectHover d-none">
                  <img @click.stop="editClick(item)" alt="" class="w-15 h-15 m-r-10"
                       src="../../../assets/common/ic_xiugai.png">
                  <img @click.stop="deleteClick(item)" alt="" class="w-15 h-15"
                       src="../../../assets/common/ic_shanchu1.png">
                </div>
              </li>
            </ul>
          </div>
        </div>
        <div class=" h-full  flex-s-0" style="width:20%;border-right: 1px solid #EDEDED">
          <div class="fs-16 flex a-center p-h-15" style="color: #333333;height: 50px;border-bottom: 1px solid #EDEDED;">
            <slot name="classType">
              <div class="fs-14">病害分类</div>
            </slot>
            <div class="flex-1"></div>
          </div>
          <div class="o-y-auto noscroll" style="height: calc(100% - 50px)">
            <ul v-if="cropModel.cropId">
              <li v-for="(item,index) in diseaseTypeList" :key="index"
                  :class="{'active': cropModel.diseaseTypeId === item.id}"
                  @click="onDiseaseTypeListSelect(item)"
                  class="w-full p-h-15 lh-40 h-40 liHover flex a-center j-between">
                {{ item.name }}
              </li>
            </ul>
          </div>
        </div>
        <div class=" h-full  flex-s-0" style="width:20%;border-right: 1px solid #EDEDED">
          <div class="fs-16 flex a-center p-h-15" style="color: #333333;height: 50px;border-bottom: 1px solid #EDEDED;">
            <slot name="classType">
              <div class="fs-14">防治对象</div>
            </slot>
            <div class="flex-1"></div>
            <div @click="addClick(2)" class="flex a-center"
                 v-if="cropModel.typeId && cropModel.cropId && cropModel.diseaseTypeId">
              <span class="fs-14" style="color: #0652DD;cursor: pointer">添加</span>
            </div>
          </div>
          <div class="o-y-auto noscroll" style="height: calc(100% - 50px)">
            <ul>
              <li v-for="(item,index) in diseaseList" :key="index"
                  :class="{'active': cropModel.diseaseId === item.id}"
                  @click="onDiseaseSelect(item)"
                  class="w-full p-h-15 lh-40 h-40 liHover flex a-center j-between">
                {{ item.name }}
                <div :class="{'selectHover1':cropModel.diseaseId === item.id}" class="selectHover d-none">
                  <img @click.stop="editClick(item)" alt="" class="w-15 h-15 m-r-10"
                       src="../../../assets/common/ic_xiugai.png">
                  <img @click.stop="deleteClick(item)" alt="" class="w-15 h-15"
                       src="../../../assets/common/ic_shanchu1.png">
                </div>
              </li>
            </ul>
          </div>
        </div>
        <div class=" h-full  flex-s-0" style="width:20%;">
          <div class="fs-16 flex a-center p-h-15" style="color: #333333;height: 50px;border-bottom: 1px solid #EDEDED;">
            <slot name="classType">
              <div class="fs-14">图例</div>
            </slot>
            <div class="flex-1"></div>
            <div class="flex a-center" v-if="cropModel.diseaseId">
              <el-upload class="avatar-uploader" multiple ref="upload" action="string"
                         accept="image/jpeg,image/png,image/jpg"
                         :before-upload="onBeforeUploadImage" :http-request="UploadImage" :show-file-list="false"
                         :on-change="fileChange">
                <el-button size="small" icon="el-icon-upload" type="primary">点击添加</el-button>
              </el-upload>
            </div>
          </div>
          <div class="o-y-auto noscroll" style="height: calc(100% - 50px)">
            <draggable element="ul" class="wrapper" v-model="cropImageLists" @end="moveEnd"
                       :options="{ animation: 120, filter: '.drag__nomove' }">
              <li v-for="(item,index) in cropImageLists" :key="index" class="m-h-10 b-b">
                <div class="flex p-v-5 a-center">
                  <img v-img-url="getFileImage(item.filePath)" alt="" class="w-50 h-50">
                  <div class="flex-1"></div>
                  <img @click.stop="deleteImageClick(item)" alt="" class="w-15 h-15"
                       src="../../../assets/common/ic_shanchu1.png">
                </div>
              </li>
            </draggable>
          </div>
        </div>
      </div>
    </div>

    <!--添加-->
    <Add v-if="open_add" :open_add="open_add" :addform="categoryModel"
         @closeDialog="closeDialogFunc($event, 'add')"></Add>
    <!--修改-->
    <Edit v-if="open_edit" :open_edit="open_edit" :editform="categoryModel"
          @closeDialog="closeDialogFunc($event, 'edit')"></Edit>
  </div>
</template>

<script>
import CropApi from '@/api/crop.js'
import Add from './Add.vue'
import Edit from './Edit.vue'
import FileApi from '@/api/file.js'
import draggable from 'vuedraggable'

export default {
  components: {
    Add,
    Edit,
    draggable
  },
  data () {
    return {
      /*是否加载完成*/
      loading: true,

      /*是否打开添加弹窗*/
      open_add: false,
      /*是否打开编辑弹窗*/
      open_edit: false,
      /*当前编辑的对象*/
      categoryModel: {
        // catList: [],
        model: {}
      },
      cropModel: {
        typeId: 0,
        typeName: '',
        cropId: 0,
        cropName: '',
        diseaseTypeId: 0,
        diseaseId: 0,
        diseaseName: ''
      },
      diseaseTypeList: [{
        id: 1,
        name: '病害'
      }, {
        id: 2,
        name: '虫害'
      }],
      /*列表数据*/
      tableData: [],
      cropList: [],
      diseaseList: [],
      cropImageLists: [],
      selectLevel: undefined,
      selectParentId: undefined
    }
  },
  computed: {
    getDisease () {
      return {
        cropId: this.cropModel.cropId,
        diseaseTypeId: this.cropModel.diseaseTypeId
      }
    }
  },
  watch: {
    'cropModel.typeId': {
      handler (newValue) {
        if (newValue) {
          this.getCropData(newValue)
        } else {
          this.cropList = []
        }
      },
      immediate: true
    },
    getDisease: {
      handler (newValue) {
        if (newValue.cropId && newValue.diseaseTypeId) {
          this.getDiseaseList(newValue.cropId, newValue.diseaseTypeId)
        } else {
          this.diseaseList = []
        }
      },
      immediate: true,
      deep: true
    },
    'cropModel.diseaseId': {
      handler (newValue) {
        if (newValue) {
          this.getCropImageList()
        } else {
          this.cropImageLists = []
        }
      },
      immediate: true
    }
  },
  created () {
    /*获取列表*/
    this.getCropType()
  },
  methods: {
    hasImages (e) {
      if (e) {
        return e
      } else {
        return ''
      }
    },
    getCropType () {
      let self = this
      CropApi.cropListByParentId({
        parentId: 0
      }, true)
        .then(res => {
          self.tableData = res.data
          if (!this.cropModel.typeId && self.tableData.length) {
            this.cropModel.typeId = self.tableData[0].id
          } else if (this.cropModel.typeId && self.tableData.length) {
            let item = self.tableData.find(e => {
              return e.id === this.cropModel.typeId
            })
            if (!item) {
              this.cropModel.typeId = self.tableData[0].id
            }
          }
        })
        .catch(error => {
        })
    },
    getCropData (parentId) {
      let self = this
      CropApi.cropListByParentId({
        parentId: parentId
      }, true)
        .then(res => {
          self.cropList = res.data
          if (!this.cropModel.cropId && self.cropList.length) {
            this.cropModel.cropId = self.cropList[0].id
          } else if (this.cropModel.cropId && self.cropList.length) {
            let item = self.cropList.find(e => {
              return e.id === this.cropModel.cropId
            })
            if (!item) {
              this.cropModel.cropId = self.cropList[0].id
            }
          }
          if (!this.cropModel.diseaseTypeId) {
            this.cropModel.diseaseTypeId = 1
          }
        })
        .catch(error => {
        })
    },
    getDiseaseList (parentId, diseaseTypeId) {
      let self = this
      CropApi.cropListByParentId({
        parentId: parentId,
        levelType: diseaseTypeId
      }, true)
        .then(res => {
          self.diseaseList = res.data
          if (!this.cropModel.diseaseId && self.diseaseList.length) {
            this.cropModel.diseaseId = self.diseaseList[0].id
          } else if (this.cropModel.diseaseId && self.diseaseList.length) {
            let item = self.diseaseList.find(e => {
              return e.id === this.cropModel.cropId
            })
            if (!item) {
              this.cropModel.diseaseId = self.diseaseList[0].id
            }
          }
        })
        .catch(error => {
        })
    },

    /*获取列表*/
    getData () {
      if (this.selectLevel === 0) {
        this.getCropType()
      } else if (this.selectLevel === 1 && this.selectParentId) {
        this.getCropData(this.selectParentId)
      } else if (this.selectLevel === 2 && this.selectParentId) {
        this.getDiseaseList(this.selectParentId, this.cropModel.diseaseTypeId)
      }
    },
    /*打开添加*/
    addClick (level) {
      let parentId = 0
      let parentLabel = ''
      if (level === 1) {
        parentId = this.cropModel.typeId
        parentLabel = this.cropModel.typeName
      } else if (level === 2) {
        parentId = this.cropModel.cropId
        parentLabel = this.cropModel.cropName
        this.categoryModel.model.levelType = this.cropModel.diseaseTypeId
      }
      this.selectLevel = level
      this.selectParentId = parentId
      this.categoryModel.model.parentId = parentId
      this.categoryModel.model.parentLabel = parentLabel
      this.categoryModel.model.level = level
      this.open_add = true
    },

    /*打开编辑*/
    editClick (item) {
      this.selectLevel = item.level
      this.selectParentId = item.parentId
      let level = item.level
      let parentLabel = ''
      if (level === 1) {
        parentLabel = this.cropModel.typeName
      } else if (level === 2) {
        parentLabel = this.cropModel.cropName
      }
      this.categoryModel.model = item
      this.categoryModel.model.parentLabel = parentLabel
      this.open_edit = true
    },
    findResult (list, objItem) {
      return list.filter(item => {
        return item.id !== objItem.id
      }).map(item => {
        item = Object.assign({}, item)
        if (item.children) {
          item.children = this.findResult(item.children, objItem)
        }
        return item
      })
    },
    /*关闭弹窗*/
    closeDialogFunc (e, f) {
      if (f == 'add') {
        this.open_add = e.openDialog
        if (e.type == 'success') {
          this.getData()
        }
      }
      if (f == 'edit') {
        this.open_edit = e.openDialog
        if (e.type == 'success') {
          this.getData()
        }
      }
    },
    /*删除分类*/
    deleteClick (row) {
      let self = this
      self.$confirm('删除后不可恢复，确认删除该记录吗?', '提示', {
        type: 'warning'
      }).then(() => {
        CropApi.cropDel({
          cropId: row.id
        }).then(data => {
          self.$message({
            message: '删除成功',
            type: 'success'
          })
          if (row.level === 0) {
            self.getCropType()
          } else if (row.level === 1 && row.parentId) {
            self.getCropData(row.parentId)
          } else if (row.level === 2 && row.parentId) {
            self.getDiseaseList(row.parentId, row.levelType)
          }

        })
      })
    },
    onTypeSelect (item) {
      this.cropModel.typeId = item.id
      this.cropModel.typeName = item.name
      this.cropModel.cropId = 0
      this.cropModel.cropName = ''
      this.cropModel.diseaseId = 0
      this.cropModel.diseaseName = ''
    },
    onCropSelect (item) {
      this.cropModel.cropId = item.id
      this.cropModel.cropName = item.name
      this.cropModel.diseaseId = 0
      this.cropModel.diseaseName = ''
    },
    onDiseaseTypeListSelect (item) {
      this.cropModel.diseaseTypeId = item.id
      this.cropModel.diseaseId = 0
      this.cropModel.diseaseName = ''
    },
    onDiseaseSelect (item) {
      this.cropModel.diseaseId = item.id
      this.cropModel.diseaseName = item.name
    },
    /*选择图片之前*/
    onBeforeUploadImage (file) {
      return true
    },
    UploadImage (param) {
      let self = this
      const loading = this.$loading({
        lock: true,
        text: '文件上传中,请等待',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })
      const formData = new FormData()
      formData.append('iFile', param.file)
      formData.append('groupId', 0)
      formData.append('fileType', 'image')
      FileApi.uploadFile(formData)
        .then(response => {
          loading.close()
          let cropImageList = [{
            cropId: self.cropModel.diseaseId,
            filePath: response.data
          }]
          let params = {
            cropId: self.cropModel.diseaseId,
            cropImageList: cropImageList
          }
          CropApi.cropImageAdd(params).then(res => {
            self.getCropImageList()
          })
          // 但是我们上传成功了图片， fileList 里面的值却没有改变，还好有on-change指令可以使用
        })
        .catch(response => {
          loading.close()
          self.$message({
            message: '本次上传文件失败',
            type: 'warning'
          })
          param.onError()
        })
    },
    /*选择上传图片*/
    fileChange (e) {
      console.log(e)
    },
    getCropImageList () {
      let params = {
        cropId: this.cropModel.diseaseId,
      }
      CropApi.cropImageList(params).then(res => {
        this.cropImageLists = res.data || []
      })
    },
    deleteImageClick (item) {
      let self = this
      self.$confirm('删除后不可恢复，确认删除该图例吗?', '提示', {
        type: 'warning'
      }).then(() => {
        CropApi.cropImageDel({
          id: item.id
        }).then(data => {
          self.$message({
            message: '删除成功',
            type: 'success'
          })
          self.getCropImageList()
        })
      })
    },
    moveEnd (evt) {
      console.log(evt, evt.from.id, evt.to.id)
      if (evt.newIndex != evt.oldIndex) {
        let cropImageList = this.cropImageLists.map(item => {
          return {
            cropId: item.cropId,
            filePath: item.filePath
          }
        })
        let params = {
          cropId: this.cropModel.diseaseId,
          cropImageList: cropImageList
        }
        CropApi.draggeCropImage(params).then(res => {
          this.getCropImageList()
        })
      }
    },
    getFileImage (filePath) {
      // if (filePath.startsWith('http://sngj.laodao.so/')) {
      //   return filePath + '@!pc-list'
      // }
      return filePath + '?x-oss-process=image/resize,w_50,limit_0/format,webp'
    }
  }
}
</script>

<style scoped>
.active {
  background: #EDF3FF;
  color: #0652DD;
}

.liHover:hover {
  background: #EDF3FF;

}

.liHover:hover .selectHover {
  display: flex;

}

.selectHover1 {
  display: flex;
}

.w-15 {
  width: 15px;
}

.h-15 {
  height: 15px;
}
</style>



// WEBPACK FOOTER //
// src/views/product/crop/index.vue